"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get MeetingNoteParticipantSchema () {
        return MeetingNoteParticipantSchema;
    },
    get MeetingNoteRoleSchema () {
        return MeetingNoteRoleSchema;
    },
    get MeetingNoteVisibilitySchema () {
        return MeetingNoteVisibilitySchema;
    },
    get MeetingNotesSchema () {
        return MeetingNotesSchema;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _base = require("../base");
const _meetinguseractionrecord = require("./meeting-user-action-record");
const MeetingNoteVisibilitySchema = _zod.z.union([
    _zod.z.literal("private"),
    _zod.z.literal("public")
]);
const MeetingNoteRoleSchema = _zod.z.union([
    _zod.z.literal("editor"),
    _zod.z.literal("viewer")
]);
const MeetingNoteParticipantSchema = _zod.z.object({
    /** Foreign key - user document */ user_id: _zod.z.instanceof(_bson.ObjectId),
    role: MeetingNoteRoleSchema
});
const MeetingNotesSchema = _base.BaseDocument.extend({
    /** Foreign key - meeting document */ meeting_id: _zod.z.instanceof(_bson.ObjectId),
    content: _zod.z.string(),
    participants: _zod.z.array(MeetingNoteParticipantSchema),
    visibility: MeetingNoteVisibilitySchema,
    updated: _meetinguseractionrecord.UserActionRecord
});
